
{
  "familyId": "STU-SAMENVATTEN",
  "questions": [
    {
      "id": "STU-SAMENVATTEN-001",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Je moet een tekst van 3 pagina's samenvatten. Wat doe je als eerste?",
      "options": ["De hele tekst doorlezen", "Meteen beginnen met schrijven", "Alleen de eerste alinea lezen", "De moeilijke woorden opzoeken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Samenvatten: eerste stap", "content": "Lees altijd eerst de hele tekst door. Zo begrijp je het grote plaatje voordat je gaat samenvatten.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_eerste_stap",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De eerste stap is de hele tekst doorlezen. Zo krijg je een overzicht van het onderwerp en de opbouw. Pas daarna kun je bepalen wat belangrijk is.",
        "solutionSteps": ["Stap 1: Lees de hele tekst door", "Stap 2: Bepaal de hoofdgedachte", "Stap 3: Markeer de belangrijkste punten", "Stap 4: Schrijf de samenvatting"],
        "distractorExplanations": {
          "0": "Goed! Eerst de hele tekst doorlezen geeft je een overzicht.",
          "1": "Je dacht waarschijnlijk dat je meteen kunt beginnen. Maar zonder de hele tekst te kennen, mis je misschien het belangrijkste punt. Onthoud: eerst lezen, dan schrijven.",
          "2": "Je dacht waarschijnlijk dat de eerste alinea genoeg is. Maar de hoofdgedachte kan ook in het midden of aan het einde staan. Onthoud: lees altijd de hele tekst.",
          "3": "Je dacht waarschijnlijk dat moeilijke woorden eerst moeten. Dat kan helpen, maar de eerste stap is de hele tekst doorlezen voor het overzicht."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-002",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Welke techniek helpt het meest bij het samenvatten van een tekst?",
      "options": ["Kernwoorden markeren per alinea", "De tekst letterlijk overschrijven", "Alleen de titel lezen", "Elke zin in je eigen woorden schrijven"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Kernwoorden markeren", "content": "Markeer per alinea 1-3 kernwoorden. Die vormen het skelet van je samenvatting. Schrijf daarna in je eigen woorden wat de alinea vertelt.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_techniek",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Kernwoorden markeren per alinea is de beste techniek. Zo vind je snel de belangrijkste informatie en kun je die in je eigen woorden opschrijven.",
        "solutionSteps": ["Lees elke alinea", "Markeer 1-3 kernwoorden per alinea", "Gebruik die kernwoorden als basis voor je samenvatting", "Schrijf in je eigen woorden"],
        "distractorExplanations": {
          "0": "Goed! Kernwoorden markeren helpt je de belangrijkste informatie te vinden.",
          "1": "Je dacht waarschijnlijk dat overschrijven helpt. Maar samenvatten is juist het tegenovergestelde: je maakt de tekst korter. Onthoud: samenvatten ≠ overschrijven.",
          "2": "Je dacht waarschijnlijk dat de titel genoeg is. Maar de titel geeft alleen het onderwerp, niet de inhoud. Onthoud: je moet de hele tekst lezen om goed samen te vatten.",
          "3": "Je dacht waarschijnlijk dat je elke zin moet herschrijven. Maar dan wordt je samenvatting net zo lang als de tekst. Onthoud: selecteer alleen de belangrijkste informatie."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-003",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Een alinea vertelt over drie soorten wolken: stapelwolken, sluierwolken en regenwolken. Welk kernwoord past het best bij deze alinea?",
      "options": ["wolkensoorten", "weer", "regen", "lucht"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Kernwoord kiezen", "content": "Een goed kernwoord dekt de hele alinea. 'Wolkensoorten' dekt alle drie de genoemde wolken. 'Regen' dekt maar één soort.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_kernwoord",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Wolkensoorten' is het beste kernwoord omdat het alle drie de genoemde wolken dekt. De andere woorden zijn te breed (weer, lucht) of te smal (regen).",
        "solutionSteps": ["De alinea gaat over: stapelwolken, sluierwolken, regenwolken", "Wat hebben ze gemeen? Het zijn allemaal wolkensoorten", "'Wolkensoorten' dekt de hele alinea ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Wolkensoorten' dekt alle drie de genoemde wolken.",
          "1": "Je dacht waarschijnlijk dat 'weer' past. Maar 'weer' is te breed — het gaat ook over temperatuur, wind, etc. Onthoud: kies een kernwoord dat precies past, niet te breed en niet te smal.",
          "2": "Je dacht waarschijnlijk dat 'regen' past. Maar de alinea gaat over drie soorten wolken, niet alleen regenwolken. Onthoud: het kernwoord moet de hele alinea dekken.",
          "3": "Je dacht waarschijnlijk dat 'lucht' past. Maar 'lucht' is te breed — de alinea gaat specifiek over wolkensoorten. Onthoud: wees zo specifiek mogelijk."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-004",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Wat hoort NIET in een goede samenvatting?",
      "options": ["Voorbeelden en details uit de tekst", "De hoofdgedachte", "De belangrijkste punten", "De conclusie van de schrijver"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Wat laat je weg?", "content": "In een samenvatting laat je details, voorbeelden en herhalingen weg. Je houdt alleen de hoofdgedachte en de belangrijkste punten over.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_weglaten",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Voorbeelden en details horen niet in een samenvatting. Je houdt alleen de hoofdgedachte, de belangrijkste punten en de conclusie over. Zo wordt je samenvatting kort en krachtig.",
        "solutionSteps": ["Wel in samenvatting: hoofdgedachte, belangrijkste punten, conclusie", "Niet in samenvatting: voorbeelden, details, herhalingen", "Voorbeelden en details laat je weg ✓"],
        "distractorExplanations": {
          "0": "Goed! Voorbeelden en details laat je weg in een samenvatting.",
          "1": "Je dacht waarschijnlijk dat de hoofdgedachte er niet in hoort. Maar de hoofdgedachte is juist het allerbelangrijkste onderdeel! Onthoud: begin je samenvatting altijd met de hoofdgedachte.",
          "2": "Je dacht waarschijnlijk dat de belangrijkste punten er niet in horen. Maar die vormen de kern van je samenvatting. Onthoud: neem per alinea het belangrijkste punt mee.",
          "3": "Je dacht waarschijnlijk dat de conclusie er niet in hoort. Maar de conclusie is het eindpunt van de tekst en hoort er wel in. Onthoud: de conclusie is de afronding."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-005",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "ordering",
      "question": "Zet de stappen voor het samenvatten in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["Lees de hele tekst door", "Markeer kernwoorden per alinea", "Bepaal de hoofdgedachte", "Schrijf de samenvatting in je eigen woorden"],
        "correctOrder": [0, 2, 1, 3]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Volgorde samenvatten", "content": "1) Lees de hele tekst. 2) Bepaal de hoofdgedachte. 3) Markeer kernwoorden per alinea. 4) Schrijf in je eigen woorden.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_volgorde",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De juiste volgorde: 1) Lees de hele tekst, 2) Bepaal de hoofdgedachte, 3) Markeer kernwoorden per alinea, 4) Schrijf in je eigen woorden.",
        "solutionSteps": ["Stap 1: Lees de hele tekst (overzicht)", "Stap 2: Bepaal de hoofdgedachte (waar gaat het over?)", "Stap 3: Markeer kernwoorden (details selecteren)", "Stap 4: Schrijf in eigen woorden (verwerken)"]
      }
    }
  ]
}
